/* eslint-disable max-len */
import React from 'react';

const PlusIconSmall = props => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>Small Plus</title>
    <g id="Small-Plus" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <circle id="Oval-Copy" fill="currentColor" cx="9" cy="9" r="9" />
        <g id="09-Icons-/-Plus-/-S-Copy" transform="translate(3.500000, 3.500000)" fill="#FFFFFF">
          <path
            d="M5.95,2.8 L5.949,5.25 L8.4,5.25 L8.4,5.95 L5.949,5.95 L5.95,8.4 L5.25,8.4 L5.249,5.95 L2.8,5.95 L2.8,5.25 L5.249,5.25 L5.25,2.8 L5.95,2.8 Z"
            id="Small-Plus-Color"
          />
          <path
            d="M6.3,2.45 L6.299,4.9 L8.75,4.9 L8.75,6.3 L6.299,6.3 L6.3,8.75 L4.9,8.75 L4.899,6.299 L2.45,6.3 L2.45,4.9 L4.899,4.899 L4.9,2.45 L6.3,2.45 Z"
            id="Combined-Shape"
            fillRule="nonzero"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default PlusIconSmall;
